import React from "react";
import { DialogActions, DialogContent, DialogTitle, FormLabel } from "@mui/material";
import CustomInput from "../CustomInput/CustomInput";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import JamezzFormStyles from "../../views/JamezzForm/JamezzFormStyles";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import Primary from "../Typography/Primary";
import CloseIcon from "@mui/icons-material/Close";
import { useDialog } from "../../licensing/utils/DialogProvider";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import { getText } from "../../translations/utils";

const TranslationDialog = ({ classes, tKey, updateTranslations, translations, languagesToTranslate, tDefault }) => {
  const [, closeDialog] = useDialog();
  const [translation, setTranslation] = React.useState(
    languagesToTranslate.map((language) => translations[language]?.[tKey] ?? "")
  );

  const splittedKey = tKey.split(".");
  const legacyType = splittedKey[0];
  splittedKey.splice(0, 1);
  const legacyKey = splittedKey.join(".");

  const getInputsLanguages = () =>
    languagesToTranslate.map((language, index) => {
      return (
        <React.Fragment key={language}>
          <GridItem xs={4}>
            <FormLabel className={classes.labelHorizontal}>{language}</FormLabel>
          </GridItem>
          <GridItem xs={4}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                onChange: (event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  const newTranslation = [...translation];
                  newTranslation[index] = event.target.value;
                  setTranslation(newTranslation);
                },
                value: translation[index] ?? "",
              }}
            />
          </GridItem>
          <GridItem xs={4}>
            {legacyType?.length > 0 && legacyKey?.length > 0
              ? getText(legacyType, legacyKey, tDefault, [], language)
              : null}
          </GridItem>
        </React.Fragment>
      );
    });

  const onClose = () => {
    const newTranslations = {};

    languagesToTranslate.forEach((language, index) => {
      if (newTranslations[language] == null) {
        newTranslations[language] = {};
      }

      if (translations[language]?.[tKey] === translation[index]) {
        return; // continue
      }
      if (translations[language][tKey] == null && translation[index] === "") {
        return; // continue
      }

      newTranslations[language][tKey] = translation[index];
    });

    // Remove unchanged/empty language keys
    for (const [key, value] of Object.entries(newTranslations)) {
      if (Object.keys(value).length === 0) {
        delete newTranslations[key];
      }
    }

    updateTranslations(newTranslations);

    closeDialog();
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <DialogTitle>Translations</DialogTitle>
        <IconButton style={{ position: "absolute", top: 20, right: 20 }}>
          <CloseIcon onClick={closeDialog} />
        </IconButton>
      </div>
      <DialogContent>
        <GridContainer>
          <GridItem xs={4}>
            <FormLabel className={classes.labelHorizontal}>Translation key</FormLabel>
          </GridItem>
          <GridItem xs={8}>
            <div style={{ paddingTop: 5 }}>
              <Primary>{tKey}</Primary>
            </div>
          </GridItem>
          <GridItem xs={4}>
            <FormLabel className={classes.labelHorizontal}>Default value</FormLabel>
          </GridItem>
          <GridItem xs={8}>
            <div style={{ paddingTop: 5 }}>
              <Primary>{tDefault}</Primary>
            </div>
          </GridItem>
          {getInputsLanguages()}
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button color={"primary"} onClick={onClose} variant={"contained"}>
          Save
        </Button>
      </DialogActions>
    </>
  );
};

TranslationDialog.propTypes = {
  tKey: PropTypes.string.isRequired,
  tDefault: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    translations: state.translations.translations,
    displayedLanguage: state.translations.displayedLanguage,
    languagesToTranslate: state.translations.languagesToTranslate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateTranslations: (translations) => dispatch({ type: "UPDATE_TRANSLATIONS", payload: translations }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TranslationDialog, JamezzFormStyles));
